export default __webpack_public_path__ + "static/media/kitchen3-after3-1920w.ce4444bc.webp";